(function(){
  'use strict';
  if (window.__dyeseAnalysisSpeedV1) return;
  window.__dyeseAnalysisSpeedV1 = true;

  var nativeFetch = window.fetch.bind(window);
  var analysisCache = new Map();
  var lastInsee = '';
  var defaultBase = '/tools/analyse-eau';
  var MAX_CACHE = 6;

  function asUrl(input) {
    try {
      var raw = (input && typeof input === 'object' && input.url) ? input.url : String(input || '');
      return new URL(raw, window.location.origin);
    } catch (e) { return null; }
  }

  function methodOf(input, init) {
    return String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
  }

  function trimCache() {
    while (analysisCache.size > MAX_CACHE) {
      var first = analysisCache.keys().next();
      if (first.done) break;
      analysisCache.delete(first.value);
    }
  }

  window.fetch = function(input, init) {
    var u = asUrl(input);
    var method = methodOf(input, init);
    if (u && /\/api\/reseaux\/?$/.test(u.pathname)) {
      lastInsee = String(u.searchParams.get('insee') || '').toUpperCase();
    }
    if (!u || method !== 'GET' || !/\/api\/analyse\/?$/.test(u.pathname)) {
      return nativeFetch(input, init);
    }

    var key = u.toString();
    if (analysisCache.has(key)) {
      return analysisCache.get(key).then(function(res){ return res.clone(); });
    }

    var pending = nativeFetch(input, init).then(function(res){
      if (!res.ok) analysisCache.delete(key);
      return res;
    }, function(err){
      analysisCache.delete(key);
      throw err;
    });

    analysisCache.set(key, pending);
    trimCache();
    return pending.then(function(res){ return res.clone(); });
  };

  function analysisUrl(insee, udi) {
    if (!insee) return '';
    var base = defaultBase.replace(/\/$/, '');
    return base + '/api/analyse?insee=' + encodeURIComponent(insee) + (udi ? '&udi=' + encodeURIComponent(udi) : '');
  }

  function prefetch(insee, udi) {
    var url = analysisUrl(insee, udi);
    if (!url) return;
    window.fetch(url, { headers: { Accept: 'application/json' } }).then(function(res){
      if (!res.ok) throw new Error('http ' + res.status);
      return res;
    }).catch(function(){});
  }

  function primeButton(button) {
    if (!button || button.dataset.dySpeedPrimed === '1') return;
    var udi = String(button.getAttribute('data-udi') || '').trim();
    if (!udi || !lastInsee) return;
    button.dataset.dySpeedPrimed = '1';
    prefetch(lastInsee, udi);
  }

  document.addEventListener('pointerover', function(e){
    var b = e.target && e.target.closest && e.target.closest('.dyese-root .dy-step__opt[data-udi]');
    if (b) primeButton(b);
  }, true);
  document.addEventListener('focusin', function(e){
    var b = e.target && e.target.closest && e.target.closest('.dyese-root .dy-step__opt[data-udi]');
    if (b) primeButton(b);
  }, true);
  document.addEventListener('touchstart', function(e){
    var b = e.target && e.target.closest && e.target.closest('.dyese-root .dy-step__opt[data-udi]');
    if (b) primeButton(b);
  }, { passive: true, capture: true });

  function primeSingleNetwork(scope) {
    var wrap = scope && scope.querySelector ? scope : document;
    var groups = wrap.querySelectorAll('.dyese-root .dy-step__opts');
    Array.prototype.forEach.call(groups, function(group){
      if (group.dataset.dySpeedChecked === '1') return;
      var real = Array.prototype.filter.call(group.querySelectorAll('.dy-step__opt[data-udi]'), function(b){
        return !!String(b.getAttribute('data-udi') || '').trim();
      });
      if (real.length === 1 && lastInsee) {
        group.dataset.dySpeedChecked = '1';
        primeButton(real[0]);
      }
    });
  }

  function loadingCard(skeleton) {
    if (!skeleton || skeleton.dataset.dySpeedBar === '1') return;
    var results = skeleton.closest && skeleton.closest('.dy-results');
    if (!results || results.querySelector('[data-dy-speed-loading]')) return;
    var root = results.closest('.dyese-root');
    var input = root && root.querySelector('#dy-commune');
    var commune = input && input.value ? input.value.trim() : '';
    if (!commune) {
      try { commune = new URLSearchParams(location.search).get('commune') || ''; } catch (e) {}
    }
    var title = commune ? 'Préparation du rapport pour ' + commune : 'Préparation de votre rapport';
    results.innerHTML = '' +
      '<div class="dy-summary" data-dy-speed-loading role="status" aria-live="polite">' +
        '<p class="dy-eyebrow" style="margin-top:0">Analyse en cours</p>' +
        '<h2 style="margin-bottom:8px">' + escapeHtml(title) + '</h2>' +
        '<p data-dy-speed-copy style="margin-bottom:14px">Récupération des derniers contrôles sanitaires de votre réseau…</p>' +
        '<div class="dy-skeleton" data-dy-speed-bar="1" style="height:8px;min-height:8px;border-radius:999px;margin:0"></div>' +
        '<p data-dy-speed-note style="margin:12px 0 0;font-size:.82rem;color:var(--dy-muted,#667085)">Le rapport s’affiche automatiquement dès que les données sont prêtes.</p>' +
      '</div>';
    var card = results.querySelector('[data-dy-speed-loading]');
    var copy = card && card.querySelector('[data-dy-speed-copy]');
    var note = card && card.querySelector('[data-dy-speed-note]');
    window.setTimeout(function(){
      if (copy && copy.isConnected) copy.textContent = 'Agrégation des mesures et préparation du rapport…';
    }, 2600);
    window.setTimeout(function(){
      if (copy && copy.isConnected) copy.textContent = 'Finalisation de l’analyse de votre réseau…';
      if (note && note.isConnected) note.textContent = 'Lors d’une première consultation de ce réseau, la récupération des données officielles peut prendre quelques secondes.';
    }, 6500);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(c){
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  function scan(node) {
    var scope = node && node.querySelector ? node : document;
    primeSingleNetwork(scope);
    var skels = [];
    if (node && node.matches && node.matches('.dy-results .dy-skeleton:not([data-dy-speed-bar])')) skels.push(node);
    if (scope.querySelectorAll) {
      Array.prototype.forEach.call(scope.querySelectorAll('.dy-results .dy-skeleton:not([data-dy-speed-bar])'), function(s){ skels.push(s); });
    }
    skels.forEach(loadingCard);
  }

  var mo = new MutationObserver(function(records){
    records.forEach(function(record){
      Array.prototype.forEach.call(record.addedNodes || [], function(node){
        if (node && node.nodeType === 1) scan(node);
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  try {
    var qp = new URLSearchParams(location.search || '');
    var qInsee = String(qp.get('insee') || '').toUpperCase();
    var qUdi = String(qp.get('udi') || '').trim();
    if (qInsee && qUdi) {
      lastInsee = qInsee;
      prefetch(qInsee, qUdi);
    }
  } catch (e) {}
})();
